/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import RichTextInput from "../RichTextInput";
import SmallRichTextInputProps from "./SmallRichTextInputProps";

export const smallRichTextInputHeight = "9.3rem";

export default function SmallRichTextInput(props: SmallRichTextInputProps) {
    return (
        <RichTextInput
            height={smallRichTextInputHeight}
            caption={props.caption}
            feldBezeichnung={props.feldBezeichnung}
            typBezeichnung={props.typBezeichnung}
            onChange={props.onChange}
            value={props.value}
            readonly={props.readonly}
            required={props.required}
            autoFocus={props.autoFocus}
            tooltip={props.tooltip}
            ignoreTooltip={props.ignoreTooltip}
        />
    );
}
